export default __webpack_public_path__ + "images/icono-web.ebc30848b8691b0c15f36bd619f13df0.svg";